import { useRef, useCallback } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@/modern/components/ui/dialog-shadcn";
import { ConfiguratorGrid } from "./ConfiguratorGrid";

interface DashboardConfiguratorModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DashboardConfiguratorModal({
  open,
  onOpenChange,
}: DashboardConfiguratorModalProps) {
  const closeHandlerRef = useRef<(() => void) | null>(null);

  const handleClose = useCallback(() => onOpenChange(false), [onOpenChange]);

  // Register the grid's close handler so we can call it when dialog tries to close
  const registerCloseHandler = useCallback((handler: () => void) => {
    closeHandlerRef.current = handler;
  }, []);

  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) {
      // Delegate to the grid's close handler which has the confirmation logic
      if (closeHandlerRef.current) {
        closeHandlerRef.current();
      }
      return;
    }
    onOpenChange(nextOpen);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange} modal={false}>
      <DialogContent
        showCloseButton={false}
        aria-describedby={undefined}
        aria-label="Dashboard Configurator"
        className="sm:max-w-[1200px] h-[85vh] p-0 gap-0 flex flex-col overflow-hidden"
      >
        <DialogTitle className="sr-only">Dashboard Configurator</DialogTitle>
        <ConfiguratorGrid onClose={handleClose} onRegisterCloseHandler={registerCloseHandler} />
      </DialogContent>
    </Dialog>
  );
}
